import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicLayout from '../components/PublicLayout';
import { Quote, TrendingUp, Users, Briefcase } from 'lucide-react';

const SuccessStories = () => {
  const navigate = useNavigate();

  const stories = [
    {
      name: "Sarah Johnson",
      title: "CEO, TechVentures",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop",
      quote: "Success Club transformed how I network. I've closed three major deals in six months through connections made here. The quality of members and events is unmatched.",
      achievement: "$2M in new contracts"
    },
    {
      name: "Michael Chen",
      title: "Founder, GrowthLab",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop",
      quote: "The accountability partner system kept me focused and motivated. I achieved goals I'd been putting off for years. The community genuinely wants to see each other succeed.",
      achievement: "300% revenue growth"
    },
    {
      name: "Emily Rodriguez",
      title: "Investor & Advisor",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop",
      quote: "More than a network—it's a community of ambitious people with real expertise. I've found incredible investment opportunities and made genuine friendships.",
      achievement: "15 new portfolio companies"
    }
  ];

  return (
    <PublicLayout>
      <div className="public-page">
        {/* Hero Section */}
        <div className="public-page-header">
          <h1>Success Stories</h1>
          <p>
            Real results from real members who transformed their businesses through Success Club.
          </p>
        </div>

        <div className="public-page-content">
          {/* Stories */}
          <div className="space-y-12 mb-16">
            {stories.map((story, index) => (
              <div key={index} className="dashboard-card">
                <div className="grid md:grid-cols-[200px_1fr] gap-8">
                  <div>
                    <img 
                      src={story.image}
                      alt={story.name}
                      className="w-full aspect-square object-cover rounded-lg"
                    />
                  </div>
                  
                  <div>
                    <Quote className="w-12 h-12 mb-4" style={{color: 'var(--gold)'}} />
                    <p style={{fontSize: '1.25rem', fontStyle: 'italic', marginBottom: '2rem', color: 'var(--ink)', lineHeight: '1.8'}}>
                      "{story.quote}"
                    </p>
                    
                    <div className="flex items-center gap-6">
                      <div>
                        <h3 style={{fontFamily: 'var(--font-heading)', fontSize: '1.5rem', marginBottom: '0.25rem'}}>{story.name}</h3>
                        <p style={{color: 'var(--muted)'}}>{story.title}</p>
                      </div>
                      
                      <div className="ml-auto">
                        <div className="badge badge-gold" style={{fontSize: '1rem', padding: '0.75rem 1.5rem'}}>
                          {story.achievement}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Stats Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="text-center dashboard-card">
              <TrendingUp className="w-12 h-12 mx-auto mb-4" style={{color: 'var(--gold)'}} />
              <div className="text-4xl font-bold mb-2" style={{color: 'var(--ink)', fontFamily: 'var(--font-heading)'}}>$50M+</div>
              <p style={{color: 'var(--muted)', fontSize: '1.125rem'}}>Revenue Generated</p>
            </div>
            
            <div className="text-center dashboard-card">
              <Users className="w-12 h-12 mx-auto mb-4" style={{color: 'var(--gold)'}} />
              <div className="text-4xl font-bold mb-2" style={{color: 'var(--ink)', fontFamily: 'var(--font-heading)'}}>2,500+</div>
              <p style={{color: 'var(--muted)', fontSize: '1.125rem'}}>Active Members</p>
            </div>
            
            <div className="text-center dashboard-card">
              <Briefcase className="w-12 h-12 mx-auto mb-4" style={{color: 'var(--gold)'}} />
              <div className="text-4xl font-bold mb-2" style={{color: 'var(--ink)', fontFamily: 'var(--font-heading)'}}>5,000+</div>
              <p style={{color: 'var(--muted)', fontSize: '1.125rem'}}>Deals Closed</p>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center rounded-2xl p-12" style={{background: 'linear-gradient(135deg, #D4AF37 0%, #C29A4B 100%)', color: '#fff'}}>
            <h2 className="mb-4" style={{color: '#fff', fontFamily: 'var(--font-heading)', fontSize: '3rem'}}>Write Your Success Story</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto" style={{color: 'rgba(255,255,255,0.9)'}}>
              Join thousands of entrepreneurs who are achieving extraordinary results.
            </p>
            <button 
              onClick={() => navigate('/auth')}
              className="bg-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
              style={{color: '#1A1A1A'}}
            >
              Join Success Club
            </button>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default SuccessStories;